import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import { Helmet } from 'react-helmet-async';

import * as graphql from 'generated/graphql';

import FeedbackResponseComposer from 'packages/kakapo-ui-application/pages/feedback-v2/respond/FeedbackResponseComposer';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

export default function Composer(props: { requestID: string }) {
	const query = graphql.useInternalFeedbackQuery({ variables: { id: props.requestID } });

	const { t } = useTranslation();

	if (!query.data) {
		return <Spinner isLoading size="20" />;
	}

	return (
		<Box p={[3, 4, 5]} maxWidth={800}>
			<Helmet>
				<title>{t('feedback.composer.page.title')}</title>
			</Helmet>
			<FeedbackResponseComposer
				response={query.data.internalFeedback as graphql.FeedbackResponse}
			/>
		</Box>
	);
}
